import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { AuthErrorCodes } from '../../../types';
import { associateCartWithUser } from '../cart/associate-cart-with-user';
import { AUTH_IDENTIFY_ERROR, AUTH_IDENTIFY_REQUEST, AUTH_IDENTIFY_SUCCESS } from '../types';
export var identifyRequest = function identifyRequest() {
  return {
    type: AUTH_IDENTIFY_REQUEST
  };
};
/**
 * Action creator for AUTH_IDENTIFY_SUCCESS. It accepts either a string token OR
 * null, if the user is just not logged in.
 */
export var identifySuccess = function identifySuccess(token) {
  return {
    type: AUTH_IDENTIFY_SUCCESS,
    payload: {
      token: token
    }
  };
};
export var identifyError = function identifyError(error) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: AUTH_IDENTIFY_ERROR,
    error: true,
    meta: meta,
    payload: {
      error: error
    }
  };
};
export var getToken = function getToken() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var auth, token, _getState, cart;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            _context.prev = 1;
            dispatch(identifyRequest());
            _context.next = 5;
            return auth.getToken();
          case 5:
            token = _context.sent;
            dispatch(identifySuccess(token));
            _getState = getState(), cart = _getState.cart;
            if (!(cart.data.id && !cart.data.email)) {
              _context.next = 17;
              break;
            }
            _context.prev = 9;
            _context.next = 12;
            return dispatch(associateCartWithUser());
          case 12:
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](9);
            console.error('Error associating cart with user', _context.t0);
          case 17:
            return _context.abrupt("return", token);
          case 20:
            _context.prev = 20;
            _context.t1 = _context["catch"](1);
            if (_context.t1.code !== AuthErrorCodes.Unauthorized) {
              dispatch(identifyError(_context.t1));
            } else if (_context.t1.code === AuthErrorCodes.Unauthorized) {
              dispatch(identifySuccess(null));
            }
            throw _context.t1;
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 20], [9, 14]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};